import { render, staticRenderFns } from "./CorpusView.vue?vue&type=template&id=7a598ec2&scoped=true&"
import script from "./CorpusView.vue?vue&type=script&lang=js&"
export * from "./CorpusView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a598ec2",
  null
  
)

export default component.exports